/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { LegalEntityType } from '../types/utils';

export class RegisterCompanyInput {
	legalEntityType: LegalEntityType = LegalEntityType.GMBH

	name: string = ''

	registrationNumber: string = ''

	tradeRegister: string = ''
}